/** @jsx jsx */
import { jsx } from '@emotion/react';
import { RampWithNameTransform } from '@goldwasserexchange/react-topmodel';
import ouiStyle from '@goldwasserexchange/oui-style';
import { animated } from 'react-spring';
export var DomButtonContainer = function (props) {
    var innerRef = props.innerRef, type = props.type, disabled = props.disabled, onClick = props.onClick, title = props.title, float = props.float, fontSize = props.fontSize, fontWeight = props.fontWeight, color = props.color, backgroundColor = props.backgroundColor, padding = props.padding, paddingHorizontal = props.paddingHorizontal, paddingVertical = props.paddingVertical, paddingTop = props.paddingTop, paddingLeft = props.paddingLeft, paddingBottom = props.paddingBottom, paddingRight = props.paddingRight, iconContainer = props.iconContainer, baselinePadding = props.baselinePadding, childPaddingTop = props.childPaddingTop, childPaddingLeft = props.childPaddingLeft, childPaddingBottom = props.childPaddingBottom, childPaddingRight = props.childPaddingRight, margin = props.margin, marginHorizontal = props.marginHorizontal, marginVertical = props.marginVertical, marginTop = props.marginTop, marginRight = props.marginRight, marginBottom = props.marginBottom, marginLeft = props.marginLeft, borderStyle = props.borderStyle, borderHorizontalStyle = props.borderHorizontalStyle, borderVerticalStyle = props.borderVerticalStyle, borderTopStyle = props.borderTopStyle, borderLeftStyle = props.borderLeftStyle, borderBottomStyle = props.borderBottomStyle, borderRightStyle = props.borderRightStyle, borderWidth = props.borderWidth, borderHorizontalWidth = props.borderHorizontalWidth, borderVerticalWidth = props.borderVerticalWidth, borderTopWidth = props.borderTopWidth, borderLeftWidth = props.borderLeftWidth, borderBottomWidth = props.borderBottomWidth, borderRightWidth = props.borderRightWidth, borderColor = props.borderColor, borderHorizontalColor = props.borderHorizontalColor, borderVerticalColor = props.borderVerticalColor, borderTopColor = props.borderTopColor, borderLeftColor = props.borderLeftColor, borderBottomColor = props.borderBottomColor, borderRightColor = props.borderRightColor, parentBorderTopWidth = props.parentBorderTopWidth, parentBorderLeftWidth = props.parentBorderLeftWidth, parentBorderBottomWidth = props.parentBorderBottomWidth, parentBorderRightWidth = props.parentBorderRightWidth, parentBorderTopStyle = props.parentBorderTopStyle, parentBorderLeftStyle = props.parentBorderLeftStyle, parentBorderBottomStyle = props.parentBorderBottomStyle, parentBorderRightStyle = props.parentBorderRightStyle, parentBorderTopColor = props.parentBorderTopColor, parentBorderLeftColor = props.parentBorderLeftColor, parentBorderBottomColor = props.parentBorderBottomColor, parentBorderRightColor = props.parentBorderRightColor, borderRadius = props.borderRadius, borderLeftBeforeTopRadius = props.borderLeftBeforeTopRadius, borderRightBeforeTopRadius = props.borderRightBeforeTopRadius, borderLeftBeforeBottomRadius = props.borderLeftBeforeBottomRadius, borderRightBeforeBottomRadius = props.borderRightBeforeBottomRadius, borderTopRadius = props.borderTopRadius, borderRightRadius = props.borderRightRadius, borderBottomRadius = props.borderBottomRadius, borderLeftRadius = props.borderLeftRadius, borderTopLeftRadius = props.borderTopLeftRadius, borderTopRightRadius = props.borderTopRightRadius, borderBottomRightRadius = props.borderBottomRightRadius, borderBottomLeftRadius = props.borderBottomLeftRadius, borderCollapse = props.borderCollapse, borderSpacing = props.borderSpacing, hoverBackgroundColor = props.hoverBackgroundColor, flexBasis = props.flexBasis, flexGrow = props.flexGrow, flexShrink = props.flexShrink, widthLines = props.widthLines, whiteSpace = props.whiteSpace, position = props.position, lines = props.lines, top = props.top, right = props.right, bottom = props.bottom, left = props.left, zIndex = props.zIndex, display = props.display, alignItems = props.alignItems, justifyContent = props.justifyContent, textAlign = props.textAlign, overflow = props.overflow, cursor = props.cursor, transform = props.transform, animatedValues = props.animatedValues, lineFactor = props.lineFactor, children = props.children;
    var css = ouiStyle.useButtonStyle({
        float: float,
        fontSize: fontSize,
        fontWeight: fontWeight,
        color: color,
        backgroundColor: backgroundColor,
        padding: padding,
        paddingHorizontal: paddingHorizontal,
        paddingVertical: paddingVertical,
        paddingTop: paddingTop,
        paddingLeft: paddingLeft,
        paddingBottom: paddingBottom,
        paddingRight: paddingRight,
        iconContainer: iconContainer,
        baselinePadding: baselinePadding,
        childPaddingTop: childPaddingTop,
        childPaddingLeft: childPaddingLeft,
        childPaddingBottom: childPaddingBottom,
        childPaddingRight: childPaddingRight,
        margin: margin,
        marginHorizontal: marginHorizontal,
        marginVertical: marginVertical,
        marginTop: marginTop,
        marginRight: marginRight,
        marginBottom: marginBottom,
        marginLeft: marginLeft,
        borderStyle: borderStyle,
        borderHorizontalStyle: borderHorizontalStyle,
        borderVerticalStyle: borderVerticalStyle,
        borderTopStyle: borderTopStyle,
        borderLeftStyle: borderLeftStyle,
        borderBottomStyle: borderBottomStyle,
        borderRightStyle: borderRightStyle,
        borderWidth: borderWidth,
        borderHorizontalWidth: borderHorizontalWidth,
        borderVerticalWidth: borderVerticalWidth,
        borderTopWidth: borderTopWidth,
        borderLeftWidth: borderLeftWidth,
        borderBottomWidth: borderBottomWidth,
        borderRightWidth: borderRightWidth,
        borderColor: borderColor,
        borderHorizontalColor: borderHorizontalColor,
        borderVerticalColor: borderVerticalColor,
        borderTopColor: borderTopColor,
        borderLeftColor: borderLeftColor,
        borderBottomColor: borderBottomColor,
        borderRightColor: borderRightColor,
        parentBorderTopWidth: parentBorderTopWidth,
        parentBorderLeftWidth: parentBorderLeftWidth,
        parentBorderBottomWidth: parentBorderBottomWidth,
        parentBorderRightWidth: parentBorderRightWidth,
        parentBorderTopStyle: parentBorderTopStyle,
        parentBorderLeftStyle: parentBorderLeftStyle,
        parentBorderBottomStyle: parentBorderBottomStyle,
        parentBorderRightStyle: parentBorderRightStyle,
        parentBorderTopColor: parentBorderTopColor,
        parentBorderLeftColor: parentBorderLeftColor,
        parentBorderBottomColor: parentBorderBottomColor,
        parentBorderRightColor: parentBorderRightColor,
        borderRadius: borderRadius,
        borderLeftBeforeTopRadius: borderLeftBeforeTopRadius,
        borderRightBeforeTopRadius: borderRightBeforeTopRadius,
        borderLeftBeforeBottomRadius: borderLeftBeforeBottomRadius,
        borderRightBeforeBottomRadius: borderRightBeforeBottomRadius,
        borderTopRadius: borderTopRadius,
        borderRightRadius: borderRightRadius,
        borderBottomRadius: borderBottomRadius,
        borderLeftRadius: borderLeftRadius,
        borderTopLeftRadius: borderTopLeftRadius,
        borderTopRightRadius: borderTopRightRadius,
        borderBottomRightRadius: borderBottomRightRadius,
        borderBottomLeftRadius: borderBottomLeftRadius,
        borderCollapse: borderCollapse,
        borderSpacing: borderSpacing,
        hoverBackgroundColor: hoverBackgroundColor,
        flexBasis: flexBasis,
        flexGrow: flexGrow,
        flexShrink: flexShrink,
        widthLines: widthLines,
        whiteSpace: whiteSpace,
        position: position,
        lines: lines,
        top: top,
        right: right,
        bottom: bottom,
        left: left,
        zIndex: zIndex,
        display: display,
        alignItems: alignItems,
        justifyContent: justifyContent,
        textAlign: textAlign,
        overflow: overflow,
        cursor: cursor,
        transform: transform,
        lineFactor: lineFactor,
    });
    return animatedValues !== undefined
        ? (jsx("button", { ref: innerRef, 
            // eslint-disable-next-line react/button-has-type
            type: type, css: ouiStyle.mediaQuery(css), onClick: onClick, disabled: disabled, title: title },
            children,
            jsx(RampWithNameTransform, { rampName: "RippleEffect", sourceBackgroundColor: css.backgroundColor })))
        : (jsx(animated.button, { ref: innerRef, type: type, css: ouiStyle.mediaQuery(css), onClick: onClick, disabled: disabled, style: animatedValues, title: title },
            children,
            jsx(RampWithNameTransform, { rampName: "RippleEffect", sourceBackgroundColor: css.backgroundColor })));
};
export var DomButtonAContainer = function (props) {
    var innerRef = props.innerRef, type = props.type, disabled = props.disabled, onClick = props.onClick, title = props.title, display = props.display, flexDirection = props.flexDirection, alignItems = props.alignItems, justifyContent = props.justifyContent, position = props.position, flexGrow = props.flexGrow, flexShrink = props.flexShrink, flexBasis = props.flexBasis, whiteSpace = props.whiteSpace, lines = props.lines, widthLines = props.widthLines, textAlign = props.textAlign, textTransform = props.textTransform, textDecoration = props.textDecoration, fontSize = props.fontSize, lineFactor = props.lineFactor, fontWeight = props.fontWeight, padding = props.padding, paddingHorizontal = props.paddingHorizontal, paddingVertical = props.paddingVertical, paddingTop = props.paddingTop, paddingLeft = props.paddingLeft, paddingBottom = props.paddingBottom, paddingRight = props.paddingRight, iconContainer = props.iconContainer, baselinePadding = props.baselinePadding, childPaddingTop = props.childPaddingTop, childPaddingLeft = props.childPaddingLeft, childPaddingBottom = props.childPaddingBottom, childPaddingRight = props.childPaddingRight, color = props.color, minLines = props.minLines, minIcon = props.minIcon, minFontSize = props.minFontSize, minPaddingTop = props.minPaddingTop, minPaddingBottom = props.minPaddingBottom, minChildPaddingTop = props.minChildPaddingTop, minChildPaddingBottom = props.minChildPaddingBottom, minParentBorderTopWidth = props.minParentBorderTopWidth, minParentBorderBottomWidth = props.minParentBorderBottomWidth, transformOrigin = props.transformOrigin, zIndex = props.zIndex, children = props.children;
    var css = ouiStyle.useACss({
        display: display,
        flexDirection: flexDirection,
        alignItems: alignItems,
        justifyContent: justifyContent,
        position: position,
        flexGrow: flexGrow,
        flexShrink: flexShrink,
        flexBasis: flexBasis,
        whiteSpace: whiteSpace,
        lines: lines,
        widthLines: widthLines,
        textAlign: textAlign,
        textTransform: textTransform,
        textDecoration: textDecoration,
        fontSize: fontSize,
        lineFactor: lineFactor,
        fontWeight: fontWeight,
        padding: padding,
        paddingHorizontal: paddingHorizontal,
        paddingVertical: paddingVertical,
        paddingTop: paddingTop,
        paddingLeft: paddingLeft,
        paddingBottom: paddingBottom,
        paddingRight: paddingRight,
        iconContainer: iconContainer,
        baselinePadding: baselinePadding,
        childPaddingTop: childPaddingTop,
        childPaddingLeft: childPaddingLeft,
        childPaddingBottom: childPaddingBottom,
        childPaddingRight: childPaddingRight,
        color: color,
        minLines: minLines,
        minIcon: minIcon,
        minFontSize: minFontSize,
        minPaddingTop: minPaddingTop,
        minPaddingBottom: minPaddingBottom,
        minChildPaddingTop: minChildPaddingTop,
        minChildPaddingBottom: minChildPaddingBottom,
        minParentBorderTopWidth: minParentBorderTopWidth,
        minParentBorderBottomWidth: minParentBorderBottomWidth,
        transformOrigin: transformOrigin,
        zIndex: zIndex,
    });
    return (jsx("button", { ref: innerRef, 
        // eslint-disable-next-line react/button-has-type
        type: type, css: ouiStyle.mediaQuery(css), onClick: onClick, disabled: disabled, title: title }, children));
};
